const blogsList = [
  {
    id: 21,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/retention-roi.png",
    link: "/retention-roi-the-cfos-case-for-organizational-health",
    time: "10",
    title: "The Retention ROI: The CFO’s Case for Organizational Health",
    description: "For many years, 'Culture' and 'Employee Engagement' were...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 20,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/strategic-cascade.png",
    link: "/strategic-cascade-connecting-daily-tasks-to-the-north-star",
    time: "10",
    title: "Strategic Cascade: Connecting Daily Tasks to the North Star",
    description: "A common problem in large organizations is 'The Purpose'...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 19,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/meritrocacy.png",
    link: "/meritocracy-removing-bias-from-the-promotion-pipeline",
    time: "10",
    title: "Meritocracy 2.0: Removing Bias from the Promotion Pipeline",
    description:
      "One of the greatest threats to organizational health is the...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 18,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/personalization-perks.png",
    link: "/personalization-over-perks-the-new-roi-of-recognition",
    time: "10",
    title: "Personalization Over Perks: The New ROI of Recognition",
    description: "For years, corporate recognition has been synonymous...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 17,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/managers-copilot.png",
    link: "/the-managers-ai-co-pilot-automating-the-admin-tax-of-leadership",
    time: "10",
    title:
      'The Manager’s AI Co-Pilot: Automating the "Admin Tax" of Leadership',
    description: "The role of the manager has become increasingly difficult...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 16,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/organizational-velocity.png",
    link: "/organizational-velocity-why-output-matters-more-than-hours",
    time: "10",
    title: "Organizational Velocity: Why Output Matters More than Hours",
    description: "The 40-hour workweek is a relic of the industrial age...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 15,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/predictive-retention.png",
    link: "/predictive-retention-using-ai-to-spot-the-retention-redline",
    time: "10",
    title: "Predictive Retention: Using AI to Spot the 'Retention Redline'",
    description: "In the current 'War for Talent,' the most expensive...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 14,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/beyond-annual-review.png",
    link: "/beyond-the-annual-review-the-architecture-of-continuous-360-feedback",
    time: "10",
    title:
      "Beyond the Annual Review: The Architecture of Continuous 360° Feedback",
    description: "The traditional annual performance review is an...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 13,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/new-blogs-03.png",
    link: "/achieving-intensified-unison-the-blueprint-for-silo-free-scaling",
    time: "10",
    title:
      "Achieving 'Intensified Unison': The Blueprint for Silo-Free Scaling",
    description: "As a company grows, a strange and counter-productive...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 12,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/new-blogs-01.png",
    link: "/the-power-of-and-balancing-kpis-with-kpls-for-holistic-growth",
    time: "10",
    title: "The Power of 'And': Balancing KPIs with KPLs for Holistic Growth",
    description:
      "In the contemporary corporate landscape, we are often told...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 11,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/new-blog-02.jpg",
    link: "/why-automating-culture-is-way-to-scale",
    time: "10",
    title:
      "The Manager’s Force Multiplier: Why Automating Culture is the Way to Scale",
    description: "In the race for market share, businesses often overlook...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 10,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/blog-new-ar-01.jpg",
    link: "/why-most-employees-feel-unseen-364-days-year",
    time: "10",
    title:
      "The Invisible Majority: Why Most Employees Feel Unseen 364 Days a Year and Judged on the 365th",
    description:
      "In workplaces around the world, a quiet crisis plays out every...",
    profile: "ayushi-rai.avif",
    name: "Ayushi Rai",
    designation: "Marketing Specialist",
    label: "Employee Engagement",
  },
  {
    id: 9,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/remote-work/benefits-of-remote-work.jpeg",
    link: "/the-benefits-of-remote-work-how-to-maintain-productivity-and-balance",
    time: "10",
    title:
      "The Benefits of Remote Work: How to Maintain Productivity and Balance",
    description: "The trend of working at home is relatively new, but it..",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
  {
    id: 8,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/leadership/leadership-cover.webp",
    link: "/7-top-leadership-qualities-for-modern-managers",
    time: "10",
    title: "7 Top Leadership Qualities for Modern Managers",
    description: "Today’s managers are required to deliver results for an..",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
  {
    id: 7,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/effective-communication/effective-communication-image-01.webp",
    link: "/10-powerful-tips-for-effective-workplace-communication",
    time: "10",
    title: "10 Powerful Tips for Effective Workplace Communication",
    description: "Effective workplace communication is one of the most..",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
  {
    id: 6,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/goals-management/goals-management-cover-image-02.webp",
    link: "/4-effective-goal-setting-techniques-for-enhanced-workplace-productivity",
    time: "8",
    title:
      "4 Effective Goal Setting Techniques for Enhanced Workplace Productivity",
    description:
      "This all-encompassing guide will explore various goal setting..",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
  {
    id: 5,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/employee-engagement/employee-engagement-cover-image-02.webp",
    link: "/8-key-elements-of-employee-engagement-for-workplace-motivation",
    time: "15",
    title: "8 Key Elements of Employee Engagement for Workplace Motivation",
    description: "Discover 8 key ways to boost employee engagement! From....",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
  {
    id: 4,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/goals-management/goals-management-cover-image.webp",
    link: "/how-do-you-set-goals-in-your-organization",
    time: "12",
    title: "How do you set goals in your organization?",
    description:
      "Goal-setting for employees builds bridges between individuals and entire organizations, as it helps to map...",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Program Management",
  },
  {
    id: 3,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/performance-management/performance-management-cover-image.webp",
    link: "/a-comprehensive-guide-to-revolutionizing-performance-management",
    time: "7",
    title: "A Comprehensive Guide to Revolutionizing 360° Performance Feedback",
    description: "Have you had up to your neck with traditional, time...",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Performance Management",
  },
  {
    id: 2,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/employee-engagement/employee-engagement-cover-image.webp",
    link: "/how-to-improve-employee-engagement-at-your-workplace",
    time: "10",
    title: "How to improve employee engagement at your workplace?",
    description: "In the modern day, when the business environment is...",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
  {
    id: 1,
    coverImg:
      "https://storage.googleapis.com/cdn-roundtechsquare/aligned-rewards/blogs/rewarding-workplace/rewarding-workplace-cover-image.webp",
    link: "/how-to-cultivate-a-rewarding-workplace-with-employee-rewards",
    time: "15",
    title: "How to Cultivate a Rewarding Workplace with Employee Rewards?",
    description:
      "Organizations often look for me­thods that can align their...",
    profile: "hemail-adhiya.webp",
    name: "Hemali Adhiya",
    designation: "Content Specialist",
    label: "Employee Engagement",
  },
];

export default blogsList;
